<!-- Do not change this file. -->
<template>
  <div class="card mb-3 text-start border-1 border-secondary shadow-sm">
    <div class="card-header border-secondary">
      <div class="row fw-bold">
        <div class="col">
          <button
            class="btn btn-link text-decoration-none p-0"
            @click="setSortKey('fullname')"
          >
            <span class="pe-1 fw-bold">Name</span>
            <span v-show="sortKey == 'fullname'">
              <i
                v-show="sortDirection === 'asc'"
                class="bi bi-sort-alpha-down"
              ></i>
              <i
                v-show="sortDirection === 'desc'"
                class="bi bi-sort-alpha-up"
              ></i>
            </span>
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-link text-decoration-none p-0"
            @click="setSortKey('onid')"
          >
            <span class="pe-1 fw-bold">ONID</span>
            <span v-show="sortKey == 'onid'">
              <i
                v-show="sortDirection === 'asc'"
                class="bi bi-sort-alpha-down"
              ></i>
              <i
                v-show="sortDirection === 'desc'"
                class="bi bi-sort-alpha-up"
              ></i>
            </span>
          </button>
        </div>
        <div
          class="col text-capitalize"
          v-for="key in extraColumnKeys"
          :key="key"
        >
          {{ key }}
        </div>
        <div v-if="evaluation" class="col">Evaluation</div>
        <div class="col text-end">
          <button
            class="btn btn-link text-decoration-none p-0"
            @click="setSortKey('tsUpdated')"
          >
            <span class="pe-1 fw-bold">Last Updated</span>
            <span v-show="sortKey == 'tsUpdated'">
              <i
                v-show="sortDirection === 'asc'"
                class="bi bi-sort-alpha-down"
              ></i>
              <i
                v-show="sortDirection === 'desc'"
                class="bi bi-sort-alpha-up"
              ></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body py-0 px-0">
      <div
        class="py-2 hover"
        :class="{
          'border-bottom border-secondary-subtle':
            i !== sortedEntries.length - 1,
          'bg-primary-subtle fw-bold': tableFocus === user.onid
        }"
        @click="setTableFocus(user.onid)"
        v-for="(user, i) in sortedEntries"
        :key="user.onid"
      >
        <div class="row mx-2">
          <div class="col">
            <div>
              {{ user.fullname }}
            </div>
          </div>
          <div class="col">
            {{ user.onid }}
          </div>
          <div
            class="col text-truncate"
            v-for="key in extraColumnKeys"
            :key="key"
          >
            {{ user.value[key] }}
          </div>
          <div class="col" v-if="evaluation">
            <div v-if="user.completed !== undefined">
              <span
                class="badge"
                :class="{
                  'bg-success': user.completed,
                  'bg-danger': !user.completed
                }"
              >
                {{ user.completed ? "Complete" : "Incomplete" }}</span
              >
            </div>
            <div v-if="user.score !== undefined">
              <div
                class="progress position-relative border border-secondary"
                role="progressbar"
                aria-label="Progress"
                :aria-valuenow="user.score"
                aria-valuemin="0"
                aria-valuemax="100"
                style="height: 1.5rem"
              >
                <div
                  class="progress-bar bg-opacity-50"
                  :class="{
                    'bg-success': user.percent == 100,
                    'bg-warning': user.percent < 100
                  }"
                  :style="`width: ${user.percent}%;`"
                ></div>
                <div
                  class="position-absolute w-100 fw-bold d-flex justify-content-between"
                  style="height: 1.5rem"
                >
                  <div class="my-auto ps-2 d-flex">
                    <div style="width: 35px" class="text-end me-1">
                      {{ user.percent }}%
                    </div>
                    <div>Complete</div>
                  </div>
                  <div class="my-auto pe-2">
                    ({{ user.score }}/{{ user.maxScore }})
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col text-end">
            {{ user.tsUpdatedLabel }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer border-secondary">
      <div class="fw-bold small">Total Entries: {{ sortedEntries.length }}</div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "AdminSortTable",
  components: {},
  data() {
    return {
      sortKey: "fullname",
      sortDirection: "asc",
      tableFocus: ""
    };
  },
  props: {
    entries: Array,
    responseCount: Number,
    extraColumnKeys: Array,
    evaluation: Boolean
  },
  computed: {
    sortedEntries() {
      let _arr = [...this.entries];

      _arr.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortKey] > b[this.sortKey] ? 1 : -1;
        } else {
          return a[this.sortKey] < b[this.sortKey] ? 1 : -1;
        }
      });

      return _arr;
    }
  },
  methods: {
    setSortKey(key) {
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortDirection = "asc";
      }
      this.sortKey = key;
    },
    setTableFocus(onid) {
      this.tableFocus = onid;
      this.$emit("setActiveEntry", onid);
    }
  }
};
</script>

<style scoped>
.hover {
  cursor: pointer;
}
</style>
